import { constants } from './config';

const initialState = {
  loading: false,
  done: false,
  error: false,
  info: null,
};

export const serviceProductOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.POST_SERVICE_PRODUCT_ORDER:
    case constants.PUT_SERVICE_PRODUCT_ORDER:
      return {
        ...state,
        loading: true,
        error: false,
        done: false,
      };

    case constants.POST_SERVICE_PRODUCT_ORDER_SUCCESS:
    case constants.PUT_SERVICE_PRODUCT_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        done: true,
        error: false,
        info: action.payload,
      };

    case constants.POST_SERVICE_PRODUCT_ORDER_FAIL:
    case constants.PUT_SERVICE_PRODUCT_ORDER_FAIL:
      return {
        ...state,
        loading: false,
        done: false,
        error: action.payload,
      };

    case constants.RESET_SERVICE_PRODUCT_ORDER:
      return initialState;

    case constants.GET_SERVICE_PRODUCT_ORDER_FROM_SOCKETS:
      return {
        ...state,
        loading: false,
        done: true,
        info: {
          ...action.data.order,
          status: action.data.status,
          payment_intent_id: action.data.payment_intent_id,
        },
      };

    default:
      return state;
  }
};
